import React, { useEffect, useReducer, useState } from 'react'
import Table from '../../../../Setup/Shared/Table'
import Loader from '../../../../shared/Loader/Loader'
import { ServerRequestProtected, ServerRequestPublic } from '../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import AddNewAuthorization from '../../Insurrance/Authorization/AddNewAuthorization';
import GridColumnHeader from '../../../../Setup/Shared/GridColumnHeader';
import AddMasterWeek from '../MasterWeekPopup/AddMasterWeek';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import isNull from '../../../../../utils/NullChecking';
import ViewTextFile from '../../../../../utils/ViewTextFile';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import Modal from 'react-bootstrap/Modal';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

const PatientAuthorization = (props) => {
    const { InvalidApi } = { ...props }
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    const [isMasterWeekOpen, setIsMasterWeekOpen] = useState(false);
    const [masterWeekID, setMasterWeekID] = useState(0)
    //insurance List
    let InsuranceList_Modal = [{
        PatientInsuranceID: "",
        CoveragePriority: "",
        InsuranceName: "",
    }]

    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    
    const [AuthorizationData, setAuthorizationData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [IsOpenAuthorization, setIsOpenAuthorization] = useState(false);
    const [AuthorizationID, setAuthorizationID] = useState(0);
    const [PatientInsuranceID, setPatientInsuranceID] = useState(0)
    const [InsuranceListModal, setInsuranceListModal] = useState([InsuranceList_Modal]);

    const [pdfFile, setPdfFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [txtFile, setTxtFile] = useState(null);
    const [modalActive, setModalActive] = useState(false)

    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })

    const ViewPdf = (BucketPath) => {
        setImgFile(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": BucketPath
        }, 'Download').then((response) => {
            setIsLoading(false)
            if (response.type === 'application/txt') {
                const blob = response;
                const reader = new FileReader();
                reader.onload = () => {
                    const content = reader.result;
                    setTxtFile(content);
                };
                reader.readAsText(blob, 'utf-8');
            } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                setImgFile(objectURL)
            } else if (response.type === 'application/tiff') {

            }
            else if (response.type === 'application/pdf') {
                const blob = response
                const objectURL = URL.createObjectURL(blob);
                console.log(objectURL);
                setPdfFile(objectURL)
            }
            setModalActive(true)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
        })
    }

    const onCloseFileViewer = () => {
        setModalActive(false)
        setPdfFile(null)
        setTxtFile(null)
        setImgFile(null)
    }

    let columns = [
        {
            key: 'InsuranceName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'InsuranceName'} data={AuthorizationData} setData={setAuthorizationData} />),
            flex: 1,
        },
        {
            key: 'AuthorizationNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Auth.#'} sortIcon={true} type={'number'} colKey={'AuthorizationNumber'} data={AuthorizationData} setData={setAuthorizationData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <div className="d-flex">
                        <button className='btn btn-link' onClick={() => { handleOpenAuthorization(row) }} title={row?.AuthorizationNumber}>{row?.AuthorizationNumber}</button>
                        {/* <button className='border-0 bg-transparent no-width rounded eye' onClick={() => ViewFile(item?.Batch)}>
                            <i class="icon-Icon-awesome-eye"></i>
                            <p class="tool_tip xsm_text text-light">View</p>
                        </button> */}
                        {!isNull(row.AuthorizationDocument) ?
                            <div className="btnWrapper-col">
                                <button className='border-0 bg-transparent no-width rounded eye' onClick={() => ViewPdf(row.AuthorizationDocument)} >
                                    <i class="icon-Icon-awesome-eye"></i>
                                    <p class="tool_tip xsm_text text-light">View</p>
                                </button>
                            </div>
                            : <p></p>}
                    </div>
                )
            }
        },
        {
            key: 'StartDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'From Date'} sortIcon={true} type={'date'} colKey={'StartDate'} data={AuthorizationData} setData={setAuthorizationData} />),

            flex: 1,
        },
        {
            key: 'EndDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'To Date'} sortIcon={true} type={'date'} colKey={'EndDate'} data={AuthorizationData} setData={setAuthorizationData} />),

            flex: 1,
        },

        {
            key: 'ProcedureCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Svs. Code'} sortIcon={true} type={'string'} colKey={'ProcedureCode'} data={AuthorizationData} setData={setAuthorizationData} />),

            flex: 1,
        },
        // {
        //     key: 'AuthorizationType',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Type'} sortIcon={true} type={'string'} colKey={'AuthorizationType'} data={AuthorizationData} setData={setAuthorizationData} />),

        //     flex: 1,
        // },
        {
            key: 'Frequency',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Period'} sortIcon={true} type={'string'} colKey={'Frequency'} data={AuthorizationData} setData={setAuthorizationData} />),

            // minWidth: 40,
            flex: 1,
        },
        {
            key: 'TotalUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Total'} sortIcon={true} type={'number'} colKey={'TotalUnits Units'} data={AuthorizationData} setData={setAuthorizationData} />),

            // minWidth: 40,
            flex: 1,
        },
        {
            key: 'ScheduledUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Scheduled'} sortIcon={true} type={'number'} colKey={'ScheduledUnits'} data={AuthorizationData} setData={setAuthorizationData} />),

            // minWidth: 40,
            flex: 1,
        },
        {
            key: 'UtilizedUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Utilized'} sortIcon={true} type={'number'} colKey={'UtilizedUnits'} data={AuthorizationData} setData={setAuthorizationData} />),

            // minWidth: 40,
            flex: 1,
        },
        {
            key: 'RemainingUnits',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Remianing'} sortIcon={true} type={'number'} colKey={'RemainingUnits'} data={AuthorizationData} setData={setAuthorizationData} />),

            // minWidth: 40,
            flex: 1,
        },
        {
            key: 'Mon',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'M'} sortIcon={true} type={'number'} colKey={'Mon'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Tue',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'T'} sortIcon={true} type={'number'} colKey={'Tue'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Wed',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'W'} sortIcon={true} type={'number'} colKey={'Wed'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Thu',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'T'} sortIcon={true} type={'number'} colKey={'Thu'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Fri',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'F'} sortIcon={true} type={'number'} colKey={'Fri'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Sat',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'S'} sortIcon={true} type={'number'} colKey={'Sat'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        {
            key: 'Sun',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'S'} sortIcon={true} type={'number'} colKey={'Sun'} data={AuthorizationData} setData={setAuthorizationData} />),

            minWidth: 40,
            flex: 1,
        },
        // {
        //     key: 'Notes',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Notes'} sortIcon={true} type={'string'} colKey={'Notes'} data={AuthorizationData} setData={setAuthorizationData} />),

        //     // minWidth: 40,
        //     flex: 1,
        //     renderCell: ({ row }) => {
        //         return (
        //             <div className="office_name_truncate">
        //                 {row.Notes}
        //             </div>
        //         )
        //     }
        // },
    ]

    const handleInsurranceDetails = async () => {
        if (PateintIDR != -1) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientInsuranceDetails", 'post', {
                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then(async (response) => {
                setInsuranceListModal(response)
            })
                .catch((error) => {
                    setIsLoading(false)
                })
        }
    }

    const handleAuthorizationDetails = async () => {
        setAuthorizationData([]);
        let saveModal = {
            "TableName": "PatientAuthorization",
            "ID": PateintIDR,
            // "PerPage": "20",
            // "PageNo": "1"
        }
        setIsLoading(true)
        ServerRequestProtected(API_URL + '/AllPatientAuthorization', 'post', saveModal
        ).then((response) => {
            setIsLoading(false);
            handleGridHeader({ defaultData: response.Rows });
            setAuthorizationData(response?.Rows);
        }).catch(() => {
            setIsLoading(false)
        })
    }

    const handleOpenAuthorization = (data) => {
        setIsOpenAuthorization(true);
        setAuthorizationID(data?.PatientAuthorizationID)
        setPatientInsuranceID(data?.PatientInsuranceID)
    }

    const CloseInsurance = () => {
        setIsOpenAuthorization(false);
    }

    const DeleteInsurance = () => {
        setIsOpenAuthorization(false);
        handleAuthorizationDetails()
    }

    let PopupScreen = "";
    if (IsOpenAuthorization) {
        PopupScreen = <AddNewAuthorization IsOpenAuthorization={IsOpenAuthorization} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} AuthorizationID={AuthorizationID} PatientInsuranceID={PatientInsuranceID} InsuranceListModal={InsuranceListModal} />
    }

    const handleOpenMasterWeek = (e) => {
        e.stopPropagation()
        setIsMasterWeekOpen(true);
        setMasterWeekID(0)
        // setPatientInsuranceID(data?.PatientInsuranceID)
    }

    const onCloseMasterWeek = () => {
        setIsMasterWeekOpen(false);
        InvalidApi();
    }

    const onCloseMasterWeekSave = () => {
        setIsMasterWeekOpen(false);
        // LoadData()
    }

    let MasterWeekPopup = "";
    if (isMasterWeekOpen) {
        MasterWeekPopup = <AddMasterWeek isMasterWeekOpen={isMasterWeekOpen} onClose={onCloseMasterWeek} onCloseSave={onCloseMasterWeekSave} ID={masterWeekID} InvalidApi={InvalidApi} />
    }

    // useEffect(() => {
    //     handleInsurranceDetails()
    //     handleAuthorizationDetails()
    // }, [PateintIDR])

    useEffect(() => {
        if (!isNull(props?.Reload?.Reload)) {

            let data = props?.Reload?.id
            data?.map((item) => {
                if (item.key === 217) {
                    handleInsurranceDetails()
                    handleAuthorizationDetails()
                }
            })
        }
    }, [props?.Reload?.Reload, PateintIDR])

    return (
        <div className="app-accordian">
            {PopupScreen}
            {MasterWeekPopup}

            <Accordion defaultExpanded>
                <AccordionSummary
                    className='flex-row-reverse'
                    expandIcon={<ExpandMoreIcon />}
                >
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <p className='heading fs-13'>Authorizations</p>
                        <button className='btn btn-orange rounded text font-m fs-12 text-white px-10' onClick={(e) => handleOpenMasterWeek(e)}>Create Master Week</button>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="card-body p-0 act-cal-nodata">
                        {isLoading ? <Loader /> : null}
                        <Table
                            columns={columns}
                            rows={AuthorizationData}
                            dynamicClass='fill-grid DataGrid-Table hk-exp-table bg_ligt_blue overflow-auto'
                            height='100px'
                            headerRowHeight={25}
                            rowHeight={25}
                            hidePagination={true}
                            Key={21}
                            Name={'PatientAuthorization'}
                            hideColClass={'hide'}
                        />
                    </div>
                </AccordionDetails>
            </Accordion>


            <Modal show={modalActive} onHide={() => onCloseFileViewer()} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
                <Modal.Body>
                    <div className="download-header">
                        <div className='hide-me'></div>
                        <button className="btn-icon-transparent" onClick={() => onCloseFileViewer()}>
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <div className="pdfView-box">
                        {!isNull(txtFile) ? txtFile : ''}
                        {!isNull(imgFile) ? <img src={imgFile} alt='application/jpg' /> : ''}

                    </div>
                    {isLoading ? <Loader /> : null}
                    {pdfFile &&
                        <>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile}
                                    defaultScale={1}
                                    plugins={[defaultLayoutPluginInstance]} />
                            </Worker>
                        </>
                    }
                    {/* Other content */}
                </Modal.Body>
                <div className='btns-group text-end px-10 py-2 br-top-1 br-clr'>
                    <button className='btn btn-gray' onClick={() => onCloseFileViewer()}>Cancel</button>
                </div>
            </Modal>
        </div >
    )
}

export default PatientAuthorization
